import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// services routing
const PollingConfig = Loadable(lazy(() => import('views/services/polling/Config')));
const AutomationConfig = Loadable(lazy(() => import('views/services/automation/Config')));
const WorkOrderLists = Loadable(lazy(() => import('views/services/workorder_lists')));
const WorkOrderStateReset = Loadable(lazy(() => import('views/services/workorder_state_reset')));
const CounterPresets = Loadable(lazy(() => import('views/services/counter_presets')));
const NodeManagement = Loadable(lazy(() => import('views/services/node_management')));
const QuickBooksConfig = Loadable(lazy(() => import('views/services/quickbooks/Config')));
const QuickBooksPayments = Loadable(lazy(() => import('views/services/quickbooks/PaymentSplits')));
const ContactDirectory = Loadable(lazy(() => import('views/services/contact_directory')));
const BillingPage = Loadable(lazy(() => import('views/pages/Billing')));

// profile routing
const AppUserAccountProfile1 = Loadable(lazy(() => import('views/application/users/account-profile/Profile1')));

// data-grid routing (Work Orders DataGrid)
const WorkOrderListView = Loadable(lazy(() => import('views/WorkOrderListView')));

// notifications
const NotificationHistory = Loadable(lazy(() => import('views/notifications/NotificationHistory')));

const ProfitabilityCosts = Loadable(lazy(() => import('views/profitability/Costs')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/dashboard/default',
      element: <DashboardDefault />
    },
    {
      path: '/user/account',
      element: <AppUserAccountProfile1 />
    },
    {
      path: '/billing',
      element: <BillingPage />
    },
    {
      path: '/workorders',
      element: <WorkOrderListView />
    },
    {
      path: '/services/polling',
      element: <PollingConfig />
    },
    {
      path: '/services/automation',
      element: <AutomationConfig />
    },
    {
      path: '/services/workorder_lists',
      element: <WorkOrderLists />
    },
    {
      path: '/services/workorder_state_reset',
      element: <WorkOrderStateReset />
    },
    {
      path: '/services/counter_presets',
      element: <CounterPresets />
    },
    {
      path: '/services/node',
      element: <NodeManagement />
    },
    {
      path: '/services/quickbooks',
      element: <QuickBooksConfig />
    },
    {
      path: '/services/quickbooks-payments',
      element: <QuickBooksPayments />
    },
    {
      path: '/services/contact_directory',
      element: <ContactDirectory />
    },
    {
      path: '/notifications',
      element: <NotificationHistory />
    },
    { path: '/insights/costs', element: <ProfitabilityCosts /> }
  ]
};

export default MainRoutes;
